import { render, staticRenderFns } from "./ItemBaseData.vue?vue&type=template&id=50eea0ee&scoped=true"
import script from "./ItemBaseData.vue?vue&type=script&lang=js"
export * from "./ItemBaseData.vue?vue&type=script&lang=js"
import style0 from "./ItemBaseData.vue?vue&type=style&index=0&id=50eea0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eea0ee",
  null
  
)

export default component.exports